
import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Search, Plus } from 'lucide-react';
import ConversationList from './ConversationList';
import ChatWindow from './ChatWindow';
import NewChatModal from './NewChatModal';

const MessagesPage = () => {
    const { user } = useAuth();
    const [selectedConversationId, setSelectedConversationId] = useState<string | null>(null);
    const [showNewChatModal, setShowNewChatModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    return (
        <div className="h-[calc(100vh-2rem)] flex bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-800 overflow-hidden">
            <div className="w-1/3 min-w-[300px] border-r border-gray-200 dark:border-gray-800 flex flex-col">
                <div className="p-4 border-b border-gray-200 dark:border-gray-800">
                    <div className="flex items-center justify-between mb-4">
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white">Mesajlar</h2>
                        <button
                            onClick={() => setShowNewChatModal(true)}
                            className="p-2 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 dark:bg-blue-900/20 dark:text-blue-400"
                        >
                            <Plus className="w-5 h-5" />
                        </button>
                    </div>
                    <div className="relative">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                        <input
                            type="text"
                            placeholder="Sohbet ara..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="w-full pl-10 pr-4 py-2 bg-gray-50 dark:bg-gray-800 border-none rounded-xl focus:ring-2 focus:ring-blue-500 text-sm"
                        />
                    </div>
                </div>
                <div className="flex-1 overflow-y-auto">
                    <ConversationList
                        selectedId={selectedConversationId}
                        onSelect={setSelectedConversationId}
                        searchQuery={searchQuery}
                    />
                </div>
            </div>
            <div className="flex-1">
                <ChatWindow conversationId={selectedConversationId} />
            </div>

            {showNewChatModal && (
                <NewChatModal
                    onClose={() => setShowNewChatModal(false)}
                    onSuccess={(id) => {
                        setSelectedConversationId(id);
                        setShowNewChatModal(false);
                    }}
                />
            )}
        </div>
    );
};

export default MessagesPage;
